import type { Path } from 'react-hook-form';

/** Distributive over Path<T> union so we get a union of matching prefixes, not never */
type PathThatHasEmail<T> = Path<T> extends infer U ? (U extends `${infer P}.email` ? P : never) : never;
type PathThatHasAdditionalEmails<T> = Path<T> extends infer U ? (U extends `${infer P}.additional_emails` ? P : never) : never;
export type ClientEmailsFieldPrefix<T> = PathThatHasEmail<T> & PathThatHasAdditionalEmails<T>;

type PrimaryEmailPath<T> = Extract<Path<T>, `${string}.email`>;
type AdditionalEmailsArrayPath<T> = Extract<Path<T>, `${string}.additional_emails`>;
type AdditionalEmailItemPath<T> = Extract<Path<T>, `${string}.additional_emails.${number}.email`>;

export function primaryEmailPath<T>(prefix: ClientEmailsFieldPrefix<T>): PrimaryEmailPath<T> {
  return `${prefix}.email` as PrimaryEmailPath<T>;
} 
export function additionalEmailsPath<T>(prefix: ClientEmailsFieldPrefix<T>): AdditionalEmailsArrayPath<T> {
  return `${prefix}.additional_emails` as AdditionalEmailsArrayPath<T>;
}

export function additionalEmailAtPath<T>(prefix: ClientEmailsFieldPrefix<T>, index: number): AdditionalEmailItemPath<T> {
  return `${prefix}.additional_emails.${index}.email` as AdditionalEmailItemPath<T>;
}